import { render } from "./Lost.vue?vue&type=template&id=165aa73a"
import script from "./Lost.vue?vue&type=script&lang=js"
export * from "./Lost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__